export enum FormClassNameEnum {
  formGroup = 'form-group',
  formOffset = 'form-offset',
  formGroupHidden = 'form-group-hidden',
}
